export enum TAB_SIZES {
    Small = "small",
    Normal = "normal"
}
